import { Modal, message, Spin, Upload } from "antd";
import { useState, useRef, useEffect } from "react";

// css
import "./index.less";

// util
import { base64ToBlob } from "utils";

// api
import { Ossupload, GetYktCode, AddAiRecord } from "api/common";

// img
import cutout_img5 from "assets/imgs/cutout_img5.png";
import cutout_img6 from "assets/imgs/cutout_img6.png";

const { Dragger } = Upload;

const PhotoModal = (props) => {
  const {
    visible,
    setVisible,
    value,
    onChange,
    list,
    onChangeList,
    openPanelName,
  } = props;

  const [photoSpinning, setPhotoSpinning] = useState(true);
  const [photoMsgVisible, setPhotoMsgVisible] = useState(false);
  const [photoEditor, setPhotoEditor] = useState(null);
  const editorRef = useRef();

  const onReset = () => {
    setVisible(false);
    setPhotoMsgVisible(false);
    setEditImg("");
    setPhotoSpinning(true);
    photoEditor?.destroy();
  };

  useEffect(() => {
    const initPhotoEditor = async () => {
      if (!editorRef?.current) return;
      setEditImg(value);
      setPhotoSpinning(true);
      const res = await GetYktCode({});
      if (!res) return;
      if (res?.ResponseStatus) return message.error(res.ResponseMsg);

      // const member_id = member?.member_id;
      // const type =
      //   process.env.REACT_APP_CURRENTMODE === "production" ||
      //   process.env.REACT_APP_CURRENTMODE === "stage"
      //     ? "prod"
      //     : "test";
      // const ticket = type + "-" + member_id;

      // 初始化编辑器实例
      try {
        const Editor = await window.websdk.openPhotoEditor({
          container: editorRef?.current,
          config: {
            saveText: "保存",
            backButton: false, // 是否显示返回按钮
            authorize: async () => {
              // 接口调用 实时返回一次性授权码
              return res?.datas?.operateCode;
            },
            sizeConfig: {}, // 参考尺寸配置
            useServiceByTicket: async (params) => {
              const form = {
                channel: 1,
                type: params?.type,
                identity: photoMsgVisible ? "black" : "",
              };
              AddAiRecord(form).then((res) => {
                if (!res) return;
                if (res?.ResponseStatus) return;
                if (!res?.datas?.[params?.type]) {
                  setPhotoMsgVisible(true);
                }
              });
              // return Promise.resolve({ tickets: [ticket] });
              return Promise.resolve({});
            },
          },
        });
        setPhotoEditor(Editor);

        if (value) await Editor.loadByImageUrl(value);
        setPhotoSpinning(false);

        if (openPanelName) {
          await Editor.openPanel({
            name: openPanelName,
          });
        }

        await Editor.setModules({
          adjust: {
            /** 图片补白菜单 **/
            backgroundCoverColor: true,
            yktMiniProgram: false,
            yktminiProgram: false,
            yktminiprogram: false,
            ykt_mini_program: false,
          },
        });

        // 关闭编辑器
        Editor.on("backButtonClick", onReset);

        // 保存
        Editor.on("save", async (payload) => {
          const image = payload?.image;
          const blob = base64ToBlob(image);

          const formData = new FormData();
          formData.append("file", blob);
          const res = await Ossupload(formData);
          if (res?.ResponseStatus === 0) {
            const url = res.datas?.[0]?.url;
            if (onChange) {
              onChange?.(url);
              onReset();
            } else {
              onChangeList((s) => {
                const index = s.findIndex((k) => k === editImgRef.current);
                if (index !== -1) s[index] = url;
                return [...s];
              });
              setEditImg(url);
            }
          }
        });
      } catch (err) {
        console.error(err);
      }
    };

    if (visible) {
      setTimeout(() => {
        initPhotoEditor();
      }, 300);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const setInit = () => {
    window.open(
      "https://zhaoyuantou.soboten.com/chat/pc/v6/index.html?sysnum=77e4c0a567f0461cb955e178f7f38e50"
    );
  };

  //   上传图片
  const [spinning, setSpinning] = useState(false);
  const [editImg, setEditImg] = useState("");
  const editImgRef = useRef();
  useEffect(() => {
    editImgRef.current = editImg;
  }, [editImg]);
  const customRequest = async (file) => {
    enterRef.current = false;
    setSpinning(true);
    const formData = new FormData();
    formData.append("file", file.file);
    const res = await Ossupload(formData);
    setSpinning(false);
    if (!res) return;
    if (res.ResponseStatus) return message.error(res.ResponseMsg);
    const image = res.datas?.[0]?.url;
    setEditImg(res.datas?.[0]?.url);
    photoEditor.loadByImageUrl(image);
  };

  const enterRef = useRef(false);
  const handlePaste = (e) => {
    if (!enterRef.current) return;
    const data = e.clipboardData || window.clipboardData;
    if (data?.items?.length) {
      for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].type?.indexOf?.("image") !== -1) {
          const file = data.items[i].getAsFile();
          customRequest({ file });
          break;
        }
      }
    }
  };

  useEffect(() => {
    document.addEventListener("paste", handlePaste);
    return () => {
      document.removeEventListener("paste", handlePaste);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onMouseEnter = () => {
    enterRef.current = true;
  };
  const onMouseLeave = () => {
    enterRef.current = false;
  };

  return (
    <Modal
      title={false}
      width={list?.length ? 1300 : 1200}
      visible={visible}
      zIndex={1051}
      footer={false}
      onCancel={onReset}
      destroyOnClose
      centered
      wrapClassName="photo-modal"
      maskClosable={false}
    >
      <div className="flex">
        {list?.length ? (
          <div className="img-list">
            <div className="fw700 fz16 mbottom10 textC" style={{ width: 80 }}>
              选择图片
            </div>
            {list?.map?.((k, i) =>
              k ? (
                <div
                  key={i}
                  className={`img-item ${k === editImg ? "active" : ""}`}
                  onClick={() => {
                    if (k === editImg) return;
                    setEditImg(k);
                    photoEditor?.loadByImageUrl(k);
                    if (openPanelName)
                      photoEditor.openPanel({ name: openPanelName });
                  }}
                >
                  <img src={k} alt="" />
                </div>
              ) : null
            )}
          </div>
        ) : null}

        <div className="ykt-modal flex1">
          <div className="" ref={editorRef} id="ykt-editor"></div>
          <div className="box-logo">
            <img src="https://oss.fangzhifu.com/zyt_logo.jpg" alt="" />
            <span>&</span>
            <svg
              t="1742285269269"
              viewBox="0 0 1391 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2902"
              width="200"
              height="200"
            >
              <path
                d="M1241.83092337 157.87254265c-11.37899141-5.69079024-16.29176415 5.15614594-22.93921818 10.66828989-2.26544197 1.77869558-4.19948215 4.09074094-6.13352232 6.22414001-16.62704957 18.13648118-36.05289086 30.05141143-61.459499 28.62871387-37.1195904-2.13339907-68.81635998 9.78023664-96.82369548 38.76494855-5.95617058-35.74220169-25.73930445-57.080076-55.85673734-70.7724073-15.78171607-7.11219326-31.69676958-14.22568107-42.74435919-29.69670795-7.68955733-11.02428791-9.78023664-23.29392165-13.64702246-35.38490912-2.44538279-7.29083955-4.8907656-14.75903084-13.1136727-16.00437666-8.95820483-1.42269757-12.44828002 6.22414-15.96036235 12.62563176-14.00302048 26.13931678-19.44914299 54.94667694-18.89378607 84.10874059 1.20133152 65.61626137 28.36333353 117.89489493 82.28732523 155.05979418 6.13481687 4.26679813 7.71285902 8.53489083 5.77881885 14.75773628-3.66742693 12.8029835-8.06885705 25.25126352-11.91363571 38.05424704-2.44667733 8.18018734-6.11280972 9.95758838-14.71501654 6.40149175-29.58537765-12.62563177-55.14733037-31.29675725-77.75255767-53.87868286-38.34163453-37.87689529-73.01713667-79.6645907-116.2495368-112.38275098a511.23387607 511.23387607 0 0 0-30.82942893-21.51652061c-44.12174791-43.74374274 5.77881885-79.66329616 17.33775106-83.93138884 12.0689803-4.44544443 4.20077669-19.73782503-34.85285386-19.56047328s-74.7738251 13.51497955-120.29626344 31.29675725c-6.6668721 2.66674883-13.67032415 4.62279617-20.82653171 6.22414001-41.34366878-8.00283559-84.24207803-9.78023664-129.07582197-4.6240907-84.39742261 9.6028849-151.81438672 50.32388077-201.38096262 119.85094226-59.52545881 83.57539082-73.55178098 178.53236211-56.3693745 277.57748526 18.00443828 104.38120992 70.21575585 190.80199585 150.41369632 258.37301003 83.17537849 70.06041125 178.9543816 104.38120992 288.22506254 97.80236642 66.37097718-3.91338919 140.2554545-12.98162978 223.60818474-84.99938292 21.02718515 10.66958444 43.09906267 14.93767712 79.68659784 18.13777572 28.2066944 2.66674883 55.34668926-1.42269757 76.35186727-5.86814197 32.91881371-7.11219326 30.6287755-38.23159877 18.73714694-43.92109448-96.48970462-45.87843635-75.30717488-27.20731085-94.55566443-42.32104518 49.03322611-59.21476962 122.91770343-120.74158459 151.81438673-320.07717674 2.28874366-15.82573037 0.35470349-25.78331875 0-38.58630226-0.17864628-7.82418931 1.55474046-10.84823072 10.33559357-11.73628397 24.1612623-2.84539511 47.63383024-9.6028849 69.17235799-21.69387235 62.50289683-34.85285389 87.73085867-92.11157618 93.68832379-160.75058441 0.88934779-10.49093815-0.17735173-21.33787433-11.0475896-26.85001829M697.05685522 775.61973316c-93.4889649-75.0405-138.85605863-99.7571192-157.59320558-98.69041967-17.51510282 1.06669954-14.35901851 21.51652062-10.51423984 34.85285388 4.02342495 13.15898153 9.29090117 22.22722213 16.64776219 33.78615436 5.06941187 7.64683757 8.58149421 19.02712352-5.08882996 27.56201434-30.11872743 19.02712352-82.46467698-6.40149175-84.90876524-7.64554304-60.94815636-36.63154947-111.91671719-84.99938291-147.81426347-151.14769952-34.67420761-63.66021405-54.79003781-131.94322427-58.1247684-204.84903062-0.88934779-17.60442595 4.20077669-23.82856596 21.33916888-27.02995912a206.71575483 206.71575483 0 0 1 68.48236912-1.77740104c95.44630676 14.22697561 176.70965223 57.79207205 244.81401614 126.78707832 38.87627884 39.29700377 68.28301022 86.24213965 98.60109653 132.120576 32.20811219 48.7212424 66.88361435 95.1330285 111.00536226 133.18598098 15.58106263 13.33633328 28.00604097 23.47256795 39.91967667 30.94075924-35.89754627 4.09074094-95.79971571 4.97879419-136.7653793-28.09536411m44.83244942-294.29256343c0-7.82418931 6.13611141-14.04832933 13.84767588-14.04832933q2.62273454 0.04530883 4.71211932 0.8893478a13.93699903 13.93699903 0 0 1 8.93619769 13.15898153 13.86968304 13.86968304 0 0 1-13.82566874 14.04832932 13.71433845 13.71433845 0 0 1-13.67032415-14.04832932m139.21205665 72.90580637c-8.91419054 3.73474291-17.84909369 6.93613605-26.4513005 7.29083955-13.29231897 0.71199605-27.82868923-4.80014791-35.69689285-11.55763769-12.26963374-10.49223269-21.02847968-16.36037467-24.6959066-34.67550214-1.57804215-7.82418931-0.71199605-19.91517677 0.6899889-26.85001829 3.1560843-14.93767712-0.35599803-24.53926747-10.66958444-33.25280458-8.40155339-7.11348781-19.0944395-9.06953513-30.82942893-9.06953513-4.37942297 0-8.40155339-1.9547528-11.38028595-3.55609664a11.66896798 11.66896798 0 0 1-5.06811733-16.35908013c1.22204413-2.4893971 7.17950925-8.53618537 8.58019965-9.6028849 15.93576613-9.24688688 34.31820958-6.22284547 51.29996263 0.71199605 15.75970892 6.5788435 27.65133748 18.67112549 44.83374397 35.74220167 17.51510282 20.62717282 20.67118711 26.31796306 30.62877549 41.78769542 7.8915053 12.09098747 15.07101456 24.53926747 19.96178015 38.76365399 2.99944517 8.89218338-0.86734064 16.18172839-11.20293419 20.62717282"
                fill="#4D6BFE"
                p-id="2903"
              ></path>
            </svg>
            <i>模型</i>
          </div>
          <div className="box-title" onClick={setInit}></div>
          <div className="box-footer zhiCustomBtn" onClick={setInit}></div>

          {/* <div className="box-wx"></div> */}

          {/* 无额度提示 */}
          {photoMsgVisible ? (
            <div>
              <div className="box-modal1">
                <div>
                  当前功能今日使用次数已达上限，可先保存图片或继续使用其他功能~
                </div>
              </div>
              <div className="box-modal2"></div>
            </div>
          ) : null}

          {/* loading */}
          {photoSpinning ? (
            <div className="box-spinning">
              <div className="flex-center flex-centerY">
                <img src="https://oss.fangzhifu.com/zyt_logo.jpg" alt="" />
                <span>&</span>
                <svg
                  t="1742285269269"
                  viewBox="0 0 1391 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2902"
                  width="200"
                  height="200"
                >
                  <path
                    d="M1241.83092337 157.87254265c-11.37899141-5.69079024-16.29176415 5.15614594-22.93921818 10.66828989-2.26544197 1.77869558-4.19948215 4.09074094-6.13352232 6.22414001-16.62704957 18.13648118-36.05289086 30.05141143-61.459499 28.62871387-37.1195904-2.13339907-68.81635998 9.78023664-96.82369548 38.76494855-5.95617058-35.74220169-25.73930445-57.080076-55.85673734-70.7724073-15.78171607-7.11219326-31.69676958-14.22568107-42.74435919-29.69670795-7.68955733-11.02428791-9.78023664-23.29392165-13.64702246-35.38490912-2.44538279-7.29083955-4.8907656-14.75903084-13.1136727-16.00437666-8.95820483-1.42269757-12.44828002 6.22414-15.96036235 12.62563176-14.00302048 26.13931678-19.44914299 54.94667694-18.89378607 84.10874059 1.20133152 65.61626137 28.36333353 117.89489493 82.28732523 155.05979418 6.13481687 4.26679813 7.71285902 8.53489083 5.77881885 14.75773628-3.66742693 12.8029835-8.06885705 25.25126352-11.91363571 38.05424704-2.44667733 8.18018734-6.11280972 9.95758838-14.71501654 6.40149175-29.58537765-12.62563177-55.14733037-31.29675725-77.75255767-53.87868286-38.34163453-37.87689529-73.01713667-79.6645907-116.2495368-112.38275098a511.23387607 511.23387607 0 0 0-30.82942893-21.51652061c-44.12174791-43.74374274 5.77881885-79.66329616 17.33775106-83.93138884 12.0689803-4.44544443 4.20077669-19.73782503-34.85285386-19.56047328s-74.7738251 13.51497955-120.29626344 31.29675725c-6.6668721 2.66674883-13.67032415 4.62279617-20.82653171 6.22414001-41.34366878-8.00283559-84.24207803-9.78023664-129.07582197-4.6240907-84.39742261 9.6028849-151.81438672 50.32388077-201.38096262 119.85094226-59.52545881 83.57539082-73.55178098 178.53236211-56.3693745 277.57748526 18.00443828 104.38120992 70.21575585 190.80199585 150.41369632 258.37301003 83.17537849 70.06041125 178.9543816 104.38120992 288.22506254 97.80236642 66.37097718-3.91338919 140.2554545-12.98162978 223.60818474-84.99938292 21.02718515 10.66958444 43.09906267 14.93767712 79.68659784 18.13777572 28.2066944 2.66674883 55.34668926-1.42269757 76.35186727-5.86814197 32.91881371-7.11219326 30.6287755-38.23159877 18.73714694-43.92109448-96.48970462-45.87843635-75.30717488-27.20731085-94.55566443-42.32104518 49.03322611-59.21476962 122.91770343-120.74158459 151.81438673-320.07717674 2.28874366-15.82573037 0.35470349-25.78331875 0-38.58630226-0.17864628-7.82418931 1.55474046-10.84823072 10.33559357-11.73628397 24.1612623-2.84539511 47.63383024-9.6028849 69.17235799-21.69387235 62.50289683-34.85285389 87.73085867-92.11157618 93.68832379-160.75058441 0.88934779-10.49093815-0.17735173-21.33787433-11.0475896-26.85001829M697.05685522 775.61973316c-93.4889649-75.0405-138.85605863-99.7571192-157.59320558-98.69041967-17.51510282 1.06669954-14.35901851 21.51652062-10.51423984 34.85285388 4.02342495 13.15898153 9.29090117 22.22722213 16.64776219 33.78615436 5.06941187 7.64683757 8.58149421 19.02712352-5.08882996 27.56201434-30.11872743 19.02712352-82.46467698-6.40149175-84.90876524-7.64554304-60.94815636-36.63154947-111.91671719-84.99938291-147.81426347-151.14769952-34.67420761-63.66021405-54.79003781-131.94322427-58.1247684-204.84903062-0.88934779-17.60442595 4.20077669-23.82856596 21.33916888-27.02995912a206.71575483 206.71575483 0 0 1 68.48236912-1.77740104c95.44630676 14.22697561 176.70965223 57.79207205 244.81401614 126.78707832 38.87627884 39.29700377 68.28301022 86.24213965 98.60109653 132.120576 32.20811219 48.7212424 66.88361435 95.1330285 111.00536226 133.18598098 15.58106263 13.33633328 28.00604097 23.47256795 39.91967667 30.94075924-35.89754627 4.09074094-95.79971571 4.97879419-136.7653793-28.09536411m44.83244942-294.29256343c0-7.82418931 6.13611141-14.04832933 13.84767588-14.04832933q2.62273454 0.04530883 4.71211932 0.8893478a13.93699903 13.93699903 0 0 1 8.93619769 13.15898153 13.86968304 13.86968304 0 0 1-13.82566874 14.04832932 13.71433845 13.71433845 0 0 1-13.67032415-14.04832932m139.21205665 72.90580637c-8.91419054 3.73474291-17.84909369 6.93613605-26.4513005 7.29083955-13.29231897 0.71199605-27.82868923-4.80014791-35.69689285-11.55763769-12.26963374-10.49223269-21.02847968-16.36037467-24.6959066-34.67550214-1.57804215-7.82418931-0.71199605-19.91517677 0.6899889-26.85001829 3.1560843-14.93767712-0.35599803-24.53926747-10.66958444-33.25280458-8.40155339-7.11348781-19.0944395-9.06953513-30.82942893-9.06953513-4.37942297 0-8.40155339-1.9547528-11.38028595-3.55609664a11.66896798 11.66896798 0 0 1-5.06811733-16.35908013c1.22204413-2.4893971 7.17950925-8.53618537 8.58019965-9.6028849 15.93576613-9.24688688 34.31820958-6.22284547 51.29996263 0.71199605 15.75970892 6.5788435 27.65133748 18.67112549 44.83374397 35.74220167 17.51510282 20.62717282 20.67118711 26.31796306 30.62877549 41.78769542 7.8915053 12.09098747 15.07101456 24.53926747 19.96178015 38.76365399 2.99944517 8.89218338-0.86734064 16.18172839-11.20293419 20.62717282"
                    fill="#4D6BFE"
                    p-id="2903"
                  ></path>
                </svg>
                <i>模型</i>
              </div>
              <div className="flex-center flex-centerY default-color mtop20">
                <Spin size="large" />
                <div className="fz20 ml10">模型渲染中...</div>
              </div>
            </div>
          ) : !value && !editImg ? (
            <div className="upload-box-spinning">
              <div className="flex-center flex-centerY">
                <img src="https://oss.fangzhifu.com/zyt_logo.jpg" alt="" />
                <span>&</span>
                <svg
                  t="1742285269269"
                  viewBox="0 0 1391 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2902"
                  width="200"
                  height="200"
                >
                  <path
                    d="M1241.83092337 157.87254265c-11.37899141-5.69079024-16.29176415 5.15614594-22.93921818 10.66828989-2.26544197 1.77869558-4.19948215 4.09074094-6.13352232 6.22414001-16.62704957 18.13648118-36.05289086 30.05141143-61.459499 28.62871387-37.1195904-2.13339907-68.81635998 9.78023664-96.82369548 38.76494855-5.95617058-35.74220169-25.73930445-57.080076-55.85673734-70.7724073-15.78171607-7.11219326-31.69676958-14.22568107-42.74435919-29.69670795-7.68955733-11.02428791-9.78023664-23.29392165-13.64702246-35.38490912-2.44538279-7.29083955-4.8907656-14.75903084-13.1136727-16.00437666-8.95820483-1.42269757-12.44828002 6.22414-15.96036235 12.62563176-14.00302048 26.13931678-19.44914299 54.94667694-18.89378607 84.10874059 1.20133152 65.61626137 28.36333353 117.89489493 82.28732523 155.05979418 6.13481687 4.26679813 7.71285902 8.53489083 5.77881885 14.75773628-3.66742693 12.8029835-8.06885705 25.25126352-11.91363571 38.05424704-2.44667733 8.18018734-6.11280972 9.95758838-14.71501654 6.40149175-29.58537765-12.62563177-55.14733037-31.29675725-77.75255767-53.87868286-38.34163453-37.87689529-73.01713667-79.6645907-116.2495368-112.38275098a511.23387607 511.23387607 0 0 0-30.82942893-21.51652061c-44.12174791-43.74374274 5.77881885-79.66329616 17.33775106-83.93138884 12.0689803-4.44544443 4.20077669-19.73782503-34.85285386-19.56047328s-74.7738251 13.51497955-120.29626344 31.29675725c-6.6668721 2.66674883-13.67032415 4.62279617-20.82653171 6.22414001-41.34366878-8.00283559-84.24207803-9.78023664-129.07582197-4.6240907-84.39742261 9.6028849-151.81438672 50.32388077-201.38096262 119.85094226-59.52545881 83.57539082-73.55178098 178.53236211-56.3693745 277.57748526 18.00443828 104.38120992 70.21575585 190.80199585 150.41369632 258.37301003 83.17537849 70.06041125 178.9543816 104.38120992 288.22506254 97.80236642 66.37097718-3.91338919 140.2554545-12.98162978 223.60818474-84.99938292 21.02718515 10.66958444 43.09906267 14.93767712 79.68659784 18.13777572 28.2066944 2.66674883 55.34668926-1.42269757 76.35186727-5.86814197 32.91881371-7.11219326 30.6287755-38.23159877 18.73714694-43.92109448-96.48970462-45.87843635-75.30717488-27.20731085-94.55566443-42.32104518 49.03322611-59.21476962 122.91770343-120.74158459 151.81438673-320.07717674 2.28874366-15.82573037 0.35470349-25.78331875 0-38.58630226-0.17864628-7.82418931 1.55474046-10.84823072 10.33559357-11.73628397 24.1612623-2.84539511 47.63383024-9.6028849 69.17235799-21.69387235 62.50289683-34.85285389 87.73085867-92.11157618 93.68832379-160.75058441 0.88934779-10.49093815-0.17735173-21.33787433-11.0475896-26.85001829M697.05685522 775.61973316c-93.4889649-75.0405-138.85605863-99.7571192-157.59320558-98.69041967-17.51510282 1.06669954-14.35901851 21.51652062-10.51423984 34.85285388 4.02342495 13.15898153 9.29090117 22.22722213 16.64776219 33.78615436 5.06941187 7.64683757 8.58149421 19.02712352-5.08882996 27.56201434-30.11872743 19.02712352-82.46467698-6.40149175-84.90876524-7.64554304-60.94815636-36.63154947-111.91671719-84.99938291-147.81426347-151.14769952-34.67420761-63.66021405-54.79003781-131.94322427-58.1247684-204.84903062-0.88934779-17.60442595 4.20077669-23.82856596 21.33916888-27.02995912a206.71575483 206.71575483 0 0 1 68.48236912-1.77740104c95.44630676 14.22697561 176.70965223 57.79207205 244.81401614 126.78707832 38.87627884 39.29700377 68.28301022 86.24213965 98.60109653 132.120576 32.20811219 48.7212424 66.88361435 95.1330285 111.00536226 133.18598098 15.58106263 13.33633328 28.00604097 23.47256795 39.91967667 30.94075924-35.89754627 4.09074094-95.79971571 4.97879419-136.7653793-28.09536411m44.83244942-294.29256343c0-7.82418931 6.13611141-14.04832933 13.84767588-14.04832933q2.62273454 0.04530883 4.71211932 0.8893478a13.93699903 13.93699903 0 0 1 8.93619769 13.15898153 13.86968304 13.86968304 0 0 1-13.82566874 14.04832932 13.71433845 13.71433845 0 0 1-13.67032415-14.04832932m139.21205665 72.90580637c-8.91419054 3.73474291-17.84909369 6.93613605-26.4513005 7.29083955-13.29231897 0.71199605-27.82868923-4.80014791-35.69689285-11.55763769-12.26963374-10.49223269-21.02847968-16.36037467-24.6959066-34.67550214-1.57804215-7.82418931-0.71199605-19.91517677 0.6899889-26.85001829 3.1560843-14.93767712-0.35599803-24.53926747-10.66958444-33.25280458-8.40155339-7.11348781-19.0944395-9.06953513-30.82942893-9.06953513-4.37942297 0-8.40155339-1.9547528-11.38028595-3.55609664a11.66896798 11.66896798 0 0 1-5.06811733-16.35908013c1.22204413-2.4893971 7.17950925-8.53618537 8.58019965-9.6028849 15.93576613-9.24688688 34.31820958-6.22284547 51.29996263 0.71199605 15.75970892 6.5788435 27.65133748 18.67112549 44.83374397 35.74220167 17.51510282 20.62717282 20.67118711 26.31796306 30.62877549 41.78769542 7.8915053 12.09098747 15.07101456 24.53926747 19.96178015 38.76365399 2.99944517 8.89218338-0.86734064 16.18172839-11.20293419 20.62717282"
                    fill="#4D6BFE"
                    p-id="2903"
                  ></path>
                </svg>
                <i>模型</i>
              </div>

              <Spin spinning={spinning} tip="上传中...">
                <div
                  className="upload-box"
                  onMouseEnter={onMouseEnter}
                  onMouseLeave={onMouseLeave}
                >
                  <Dragger
                    customRequest={customRequest}
                    accept=".jpg,.png,.jpeg,.bmp"
                    onDrop={customRequest}
                    showUploadList={false}
                  >
                    <img className="upload-icon" src={cutout_img5} alt="" />
                    <div className="upload-text">支持粘贴或拖拽图片至此</div>
                    <div className="upload-btn">
                      <img src={cutout_img6} alt="" />
                      <span>上传图片</span>
                    </div>
                  </Dragger>
                </div>
              </Spin>
            </div>
          ) : null}
        </div>
      </div>
    </Modal>
  );
};

export default PhotoModal;
